import { gameName } from './gameConfigsAndUrls';

export const RoutePaths = {
  game: `/${gameName}/game`,
  lobby: `/${gameName}/`,
  turbo: `/${gameName}/turbo`,
};
